module.exports = __webpack_public_path__ + "static/OmarA-bad5d6016fcadfaffad2ee392f1548f6.gif";